/* tslint:disable */
/* eslint-disable */
/* @relayHash 249e0a1a36e7478a38948e42ac210c1e */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type UnansweredCommentsTabQueryVariables = {
    storyID?: string | null;
    storyURL?: string | null;
    commentsOrderBy?: COMMENT_SORT | null;
    flattenReplies: boolean;
};
export type UnansweredCommentsTabQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainer_viewer">;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainer_story">;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainer_settings">;
    };
};
export type UnansweredCommentsTabQuery = {
    readonly response: UnansweredCommentsTabQueryResponse;
    readonly variables: UnansweredCommentsTabQueryVariables;
};



/*
query UnansweredCommentsTabQuery(
  $storyID: ID
  $storyURL: String
  $commentsOrderBy: COMMENT_SORT
  $flattenReplies: Boolean!
) {
  viewer {
    ...UnansweredCommentsTabContainer_viewer
    id
  }
  story: stream(id: $storyID, url: $storyURL) {
    ...UnansweredCommentsTabContainer_story_2ntMMu
    id
  }
  settings {
    ...UnansweredCommentsTabContainer_settings
    id
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CaretContainer_settings on Settings {
  ...ModerationDropdownContainer_settings
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment CaretContainer_viewer on User {
  ...ModerationDropdownContainer_viewer
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
  }
  parent {
    id
    author {
      username
      id
    }
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
}

fragment CommentContainer_settings on Settings {
  disableCommenting {
    enabled
  }
  featureFlags
  ...CaretContainer_settings
  ...EditCommentFormContainer_settings
  ...MediaSectionContainer_settings
  ...ReactionButtonContainer_settings
  ...ReplyCommentFormContainer_settings
  ...ReportFlowContainer_settings
  ...UsernameWithPopoverContainer_settings
  ...UserTagsContainer_settings
}

fragment CommentContainer_story on Story {
  id
  url
  isClosed
  canModerate
  settings {
    mode
  }
  ...CaretContainer_story
  ...EditCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...ReplyCommentFormContainer_story
  ...UserTagsContainer_story
}

fragment CommentContainer_viewer on User {
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  badges
  role
  scheduledDeletionDate
  mediaSettings {
    unfurlEmbeds
  }
  ...UsernameWithPopoverContainer_viewer
  ...ReactionButtonContainer_viewer
  ...ReportFlowContainer_viewer
  ...ReportButton_viewer
  ...CaretContainer_viewer
}

fragment CreateCommentMutation_story on Story {
  id
  viewerRating {
    id
    tags {
      code
    }
    rating
  }
  settings {
    moderation
    mode
    live {
      enabled
    }
    experts {
      id
    }
  }
  ratings {
    count
    average
  }
}

fragment CreateCommentMutation_viewer on User {
  id
  avatar
  badges
  bio
  createdAt
  role
  username
  status {
    current
    ban {
      active
    }
  }
}

fragment CreateCommentReplyMutation_story on Story {
  settings {
    moderation
  }
}

fragment CreateCommentReplyMutation_viewer on User {
  role
  badges
  createdAt
  status {
    current
    ban {
      active
    }
  }
}

fragment DeletedTombstoneContainer_comment on Comment {
  deleted
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment EditCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
      key
      maxRating
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment IgnoredTombstoneOrHideContainer_viewer on User {
  ignoredUsers {
    id
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment LocalReplyListContainer_settings on Settings {
  ...ReplyListCommentContainer_settings
}

fragment LocalReplyListContainer_story on Story {
  ...ReplyListCommentContainer_story
}

fragment LocalReplyListContainer_viewer on User {
  ...ReplyListCommentContainer_viewer
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment MediaSectionContainer_settings on Settings {
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
    }
    external {
      enabled
    }
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment ModerationActionsContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
}

fragment ModerationActionsContainer_viewer on User {
  id
  moderationScopes {
    scoped
  }
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationDropdownContainer_settings on Settings {
  ...ModerationActionsContainer_settings
  ...UserBanPopoverContainer_settings
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment ModerationDropdownContainer_viewer on User {
  ...ModerationActionsContainer_viewer
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment RTEContainer_config on RTEConfiguration {
  enabled
  strikethrough
  spoiler
  sarcasm
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReactionButtonContainer_settings on Settings {
  reaction {
    label
    labelActive
    icon
    iconActive
  }
}

fragment ReactionButtonContainer_viewer on User {
  id
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
}

fragment ReplyCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    giphy {
      enabled
      key
      maxRating
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment ReplyListCommentContainer_comment on Comment {
  ...CommentContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment ReplyListCommentContainer_settings on Settings {
  ...CommentContainer_settings
  featureFlags
}

fragment ReplyListCommentContainer_story on Story {
  ...CommentContainer_story
}

fragment ReplyListCommentContainer_viewer on User {
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
}

fragment ReplyListContainer1_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer2_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer1_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer2_settings
}

fragment ReplyListContainer1_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer2_story
}

fragment ReplyListContainer1_viewer on User {
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainer2_viewer
}

fragment ReplyListContainer2_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer3_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer3_settings
}

fragment ReplyListContainer2_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer3_story
}

fragment ReplyListContainer2_viewer on User {
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainer3_viewer
}

fragment ReplyListContainer3_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainerLast_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainerLast_settings
}

fragment ReplyListContainer3_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainerLast_story
}

fragment ReplyListContainer3_viewer on User {
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainerLast_viewer
}

fragment ReplyListContainerLastFlattened_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC, flatten: $flattenReplies) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        __typename
      }
      __typename
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLastFlattened_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
}

fragment ReplyListContainerLastFlattened_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
}

fragment ReplyListContainerLastFlattened_viewer on User {
  ...ReplyListCommentContainer_viewer
}

fragment ReplyListContainerLast_comment on Comment {
  ...LocalReplyListContainer_comment @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_comment @include(if: $flattenReplies)
}

fragment ReplyListContainerLast_settings on Settings {
  ...LocalReplyListContainer_settings @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_settings @include(if: $flattenReplies)
}

fragment ReplyListContainerLast_story on Story {
  ...LocalReplyListContainer_story @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_story @include(if: $flattenReplies)
}

fragment ReplyListContainerLast_viewer on User {
  ...LocalReplyListContainer_viewer @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_viewer @include(if: $flattenReplies)
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportButton_viewer on User {
  id
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}

fragment ReportCommentFormContainer_settings on Settings {
  memberBios
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportFlowContainer_settings on Settings {
  ...ReportCommentFormContainer_settings
}

fragment ReportFlowContainer_viewer on User {
  id
}

fragment StaffTagContainer_settings on Settings {
  staff {
    staffLabel
    adminLabel
    moderatorLabel
  }
}

fragment UnansweredCommentsTabCommentContainer_comment on Comment {
  ...CommentContainer_comment
  ...ReplyListContainer1_comment
  ...IgnoredTombstoneOrHideContainer_comment
}

fragment UnansweredCommentsTabCommentContainer_settings on Settings {
  ...ReplyListContainer1_settings
  ...CommentContainer_settings
}

fragment UnansweredCommentsTabCommentContainer_story on Story {
  ...ReplyListContainer1_story
  ...CommentContainer_story
}

fragment UnansweredCommentsTabCommentContainer_viewer on User {
  ...ReplyListContainer1_viewer
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
}

fragment UnansweredCommentsTabContainer_settings on Settings {
  reaction {
    sortLabel
  }
  disableCommenting {
    enabled
  }
  ...UnansweredCommentsTabCommentContainer_settings
}

fragment UnansweredCommentsTabContainer_story_2ntMMu on Story {
  id
  isClosed
  settings {
    live {
      enabled
    }
  }
  commentCounts {
    tags {
      UNANSWERED
    }
  }
  comments(first: 20, orderBy: $commentsOrderBy, tag: UNANSWERED) {
    edges {
      node {
        id
        ...UnansweredCommentsTabCommentContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...CreateCommentReplyMutation_story
  ...CreateCommentMutation_story
  ...UnansweredCommentsTabCommentContainer_story
}

fragment UnansweredCommentsTabContainer_viewer on User {
  ...UnansweredCommentsTabCommentContainer_viewer
  ...CreateCommentReplyMutation_viewer
  ...CreateCommentMutation_viewer
  status {
    current
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserBanPopoverContainer_settings on Settings {
  featureFlags
}

fragment UserBanPopoverContainer_story on Story {
  id
  site {
    id
    name
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_settings on Settings {
  ...UserPopoverOverviewContainer_settings
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverContainer_viewer on User {
  ...UserPopoverOverviewContainer_viewer
}

fragment UserPopoverOverviewContainer_settings on Settings {
  memberBios
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserPopoverOverviewContainer_viewer on User {
  id
  ignoredUsers {
    id
  }
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserTagsContainer_settings on Settings {
  ...StaffTagContainer_settings
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}

fragment UsernameWithPopoverContainer_settings on Settings {
  ...UserPopoverContainer_settings
}

fragment UsernameWithPopoverContainer_viewer on User {
  ...UserPopoverContainer_viewer
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsOrderBy"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "flattenReplies"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v3 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyURL"
    } as any), v4 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v5 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "commentsOrderBy"
    } as any), v6 = ({
        "kind": "Literal",
        "name": "tag",
        "value": "UNANSWERED"
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v8 = [
        (v7 /*: any*/)
    ], v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "badges",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avatar",
        "storageKey": null
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bio",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v15 = [
        (v14 /*: any*/)
    ], v16 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 20
        } as any),
        (v5 /*: any*/),
        (v6 /*: any*/)
    ], v17 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v7 /*: any*/),
            (v13 /*: any*/),
            (v11 /*: any*/),
            (v9 /*: any*/),
            (v10 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            (v12 /*: any*/)
        ],
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v7 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v13 /*: any*/),
                    (v7 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v29 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v30 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v31 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v7 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v27 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v28 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            (v29 /*: any*/),
                            (v30 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v28 /*: any*/),
                            (v29 /*: any*/)
                        ],
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v28 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v28 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v32 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": (v8 /*: any*/),
        "storageKey": null
    } as any), v33 = ({
        "kind": "Literal",
        "name": "first",
        "value": 10
    } as any), v34 = ({
        "kind": "Literal",
        "name": "orderBy",
        "value": "CREATED_AT_ASC"
    } as any), v35 = [
        (v33 /*: any*/),
        (v34 /*: any*/)
    ], v36 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v37 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v38 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v39 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasTraversalFocus",
        "storageKey": null
    } as any), v40 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v41 = ({
        "kind": "ClientExtension",
        "selections": [
            (v37 /*: any*/),
            (v38 /*: any*/),
            (v39 /*: any*/),
            (v40 /*: any*/)
        ]
    } as any), v42 = [
        ({
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "localReplies",
            "plural": true,
            "selections": [
                (v7 /*: any*/),
                (v40 /*: any*/),
                (v17 /*: any*/),
                (v18 /*: any*/),
                (v19 /*: any*/),
                (v10 /*: any*/),
                (v20 /*: any*/),
                (v21 /*: any*/),
                (v22 /*: any*/),
                (v23 /*: any*/),
                (v37 /*: any*/),
                (v38 /*: any*/),
                (v24 /*: any*/),
                (v25 /*: any*/),
                (v26 /*: any*/),
                (v39 /*: any*/),
                (v31 /*: any*/),
                (v32 /*: any*/)
            ],
            "storageKey": null
        } as any)
    ], v43 = [
        (v33 /*: any*/),
        ({
            "kind": "Variable",
            "name": "flatten",
            "variableName": "flattenReplies"
        } as any),
        (v34 /*: any*/)
    ], v44 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v45 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v46 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v44 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v7 /*: any*/),
                    (v36 /*: any*/),
                    (v40 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v10 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v37 /*: any*/),
                    (v38 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v39 /*: any*/),
                    (v31 /*: any*/),
                    (v32 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v47 = [
        "orderBy"
    ], v48 = ({
        "alias": null,
        "args": (v43 /*: any*/),
        "filters": (v47 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v49 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": false,
        "selections": (v42 /*: any*/)
    } as any), v50 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": (v43 /*: any*/),
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "replies",
                "plural": false,
                "selections": [
                    (v46 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v7 /*: any*/),
                                    (v36 /*: any*/),
                                    (v40 /*: any*/),
                                    (v17 /*: any*/),
                                    (v18 /*: any*/),
                                    (v19 /*: any*/),
                                    (v10 /*: any*/),
                                    (v20 /*: any*/),
                                    (v21 /*: any*/),
                                    (v22 /*: any*/),
                                    (v23 /*: any*/),
                                    (v37 /*: any*/),
                                    (v38 /*: any*/),
                                    (v24 /*: any*/),
                                    (v25 /*: any*/),
                                    (v26 /*: any*/),
                                    (v39 /*: any*/),
                                    (v31 /*: any*/),
                                    (v32 /*: any*/),
                                    (v27 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v27 /*: any*/),
                            (v44 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v45 /*: any*/)
                ],
                "storageKey": null
            },
            (v48 /*: any*/)
        ]
    } as any), v51 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v44 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v7 /*: any*/),
                    (v36 /*: any*/),
                    (v40 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v10 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v37 /*: any*/),
                    (v38 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v39 /*: any*/),
                    (v31 /*: any*/),
                    (v32 /*: any*/),
                    (v49 /*: any*/),
                    (v50 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v52 = ({
        "alias": null,
        "args": (v35 /*: any*/),
        "filters": (v47 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v53 = ({
        "alias": null,
        "args": (v35 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v51 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v7 /*: any*/),
                            (v36 /*: any*/),
                            (v40 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v10 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v37 /*: any*/),
                            (v38 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v39 /*: any*/),
                            (v31 /*: any*/),
                            (v32 /*: any*/),
                            (v27 /*: any*/),
                            (v49 /*: any*/),
                            (v50 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v44 /*: any*/)
                ],
                "storageKey": null
            },
            (v45 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v54 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v44 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v7 /*: any*/),
                    (v36 /*: any*/),
                    (v40 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v10 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v37 /*: any*/),
                    (v38 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v39 /*: any*/),
                    (v31 /*: any*/),
                    (v32 /*: any*/),
                    (v53 /*: any*/),
                    (v52 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v55 = ({
        "alias": null,
        "args": (v35 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v54 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v7 /*: any*/),
                            (v36 /*: any*/),
                            (v40 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v10 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v37 /*: any*/),
                            (v38 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v39 /*: any*/),
                            (v31 /*: any*/),
                            (v32 /*: any*/),
                            (v53 /*: any*/),
                            (v52 /*: any*/),
                            (v27 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v44 /*: any*/)
                ],
                "storageKey": null
            },
            (v45 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v56 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v44 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v7 /*: any*/),
                    (v36 /*: any*/),
                    (v40 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v10 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v37 /*: any*/),
                    (v38 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v39 /*: any*/),
                    (v31 /*: any*/),
                    (v32 /*: any*/),
                    (v55 /*: any*/),
                    (v52 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v57 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "UnansweredCommentsTabQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "UnansweredCommentsTabContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v4 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v5 /*: any*/),
                                (v6 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "UnansweredCommentsTabContainer_story"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "UnansweredCommentsTabContainer_settings"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Operation",
            "name": "UnansweredCommentsTabQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "active",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "ignoredUsers",
                            "plural": true,
                            "selections": (v8 /*: any*/),
                            "storageKey": null
                        },
                        (v9 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledDeletionDate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMediaSettings",
                            "kind": "LinkedField",
                            "name": "mediaSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unfurlEmbeds",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserModerationScopes",
                            "kind": "LinkedField",
                            "name": "moderationScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scoped",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v10 /*: any*/),
                        (v11 /*: any*/),
                        (v12 /*: any*/),
                        (v13 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v4 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LiveConfiguration",
                                    "kind": "LinkedField",
                                    "name": "live",
                                    "plural": false,
                                    "selections": (v15 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderation",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentCounts",
                            "kind": "LinkedField",
                            "name": "commentCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentTagCounts",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "UNANSWERED",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v16 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v7 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/),
                                                (v10 /*: any*/),
                                                (v20 /*: any*/),
                                                (v21 /*: any*/),
                                                (v22 /*: any*/),
                                                (v23 /*: any*/),
                                                (v24 /*: any*/),
                                                (v25 /*: any*/),
                                                (v26 /*: any*/),
                                                (v31 /*: any*/),
                                                (v32 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v35 /*: any*/),
                                                    "concreteType": "CommentsConnection",
                                                    "kind": "LinkedField",
                                                    "name": "replies",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v36 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        (v23 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v25 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v31 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v35 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v7 /*: any*/),
                                                                                                (v36 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                (v19 /*: any*/),
                                                                                                (v10 /*: any*/),
                                                                                                (v20 /*: any*/),
                                                                                                (v21 /*: any*/),
                                                                                                (v22 /*: any*/),
                                                                                                (v23 /*: any*/),
                                                                                                (v24 /*: any*/),
                                                                                                (v25 /*: any*/),
                                                                                                (v26 /*: any*/),
                                                                                                (v31 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": (v35 /*: any*/),
                                                                                                    "concreteType": "CommentsConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "replies",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v7 /*: any*/),
                                                                                                                        (v36 /*: any*/),
                                                                                                                        (v17 /*: any*/),
                                                                                                                        (v18 /*: any*/),
                                                                                                                        (v19 /*: any*/),
                                                                                                                        (v10 /*: any*/),
                                                                                                                        (v20 /*: any*/),
                                                                                                                        (v21 /*: any*/),
                                                                                                                        (v22 /*: any*/),
                                                                                                                        (v23 /*: any*/),
                                                                                                                        (v24 /*: any*/),
                                                                                                                        (v25 /*: any*/),
                                                                                                                        (v26 /*: any*/),
                                                                                                                        (v31 /*: any*/),
                                                                                                                        (v32 /*: any*/),
                                                                                                                        (v27 /*: any*/),
                                                                                                                        (v41 /*: any*/),
                                                                                                                        {
                                                                                                                            "condition": "flattenReplies",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                    "selections": (v42 /*: any*/)
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "flattenReplies",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": (v43 /*: any*/),
                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "replies",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": null,
                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "alias": null,
                                                                                                                                                    "args": null,
                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        (v7 /*: any*/),
                                                                                                                                                        (v36 /*: any*/),
                                                                                                                                                        (v17 /*: any*/),
                                                                                                                                                        (v18 /*: any*/),
                                                                                                                                                        (v19 /*: any*/),
                                                                                                                                                        (v10 /*: any*/),
                                                                                                                                                        (v20 /*: any*/),
                                                                                                                                                        (v21 /*: any*/),
                                                                                                                                                        (v22 /*: any*/),
                                                                                                                                                        (v23 /*: any*/),
                                                                                                                                                        (v24 /*: any*/),
                                                                                                                                                        (v25 /*: any*/),
                                                                                                                                                        (v26 /*: any*/),
                                                                                                                                                        (v31 /*: any*/),
                                                                                                                                                        (v32 /*: any*/),
                                                                                                                                                        (v27 /*: any*/),
                                                                                                                                                        (v41 /*: any*/)
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": null
                                                                                                                                                },
                                                                                                                                                (v27 /*: any*/),
                                                                                                                                                (v44 /*: any*/)
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        },
                                                                                                                                        (v45 /*: any*/),
                                                                                                                                        {
                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                            "selections": [
                                                                                                                                                (v46 /*: any*/)
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v48 /*: any*/)
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v44 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v45 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                (v51 /*: any*/)
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                                },
                                                                                                (v52 /*: any*/),
                                                                                                (v27 /*: any*/),
                                                                                                (v41 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v44 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v45 /*: any*/),
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        (v54 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                        },
                                                                        (v52 /*: any*/),
                                                                        (v27 /*: any*/),
                                                                        (v41 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v44 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v45 /*: any*/),
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                (v56 /*: any*/)
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                },
                                                (v52 /*: any*/),
                                                (v27 /*: any*/),
                                                (v41 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v44 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v45 /*: any*/),
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "viewNewEdges",
                                            "plural": true,
                                            "selections": [
                                                (v44 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v40 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v37 /*: any*/),
                                                        (v38 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v26 /*: any*/),
                                                        (v39 /*: any*/),
                                                        (v31 /*: any*/),
                                                        (v32 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v35 /*: any*/),
                                                            "concreteType": "CommentsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "replies",
                                                            "plural": false,
                                                            "selections": [
                                                                (v56 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v36 /*: any*/),
                                                                                (v40 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v18 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v10 /*: any*/),
                                                                                (v20 /*: any*/),
                                                                                (v21 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                (v23 /*: any*/),
                                                                                (v37 /*: any*/),
                                                                                (v38 /*: any*/),
                                                                                (v24 /*: any*/),
                                                                                (v25 /*: any*/),
                                                                                (v26 /*: any*/),
                                                                                (v39 /*: any*/),
                                                                                (v31 /*: any*/),
                                                                                (v32 /*: any*/),
                                                                                (v55 /*: any*/),
                                                                                (v52 /*: any*/),
                                                                                (v27 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v44 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v45 /*: any*/)
                                                            ],
                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                        },
                                                        (v52 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v16 /*: any*/),
                            "filters": [
                                "orderBy",
                                "tag"
                            ],
                            "handle": "connection",
                            "key": "UnansweredStream_comments",
                            "kind": "LinkedHandle",
                            "name": "comments"
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "viewerRating",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v23 /*: any*/),
                                (v21 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryRatings",
                            "kind": "LinkedField",
                            "name": "ratings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "count",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "average",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedAt",
                            "storageKey": null
                        },
                        (v28 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canModerate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "site",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "kind": "LinkedField",
                            "name": "reaction",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "labelActive",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "icon",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "iconActive",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "kind": "LinkedField",
                            "name": "disableCommenting",
                            "plural": false,
                            "selections": [
                                (v14 /*: any*/),
                                (v57 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureFlags",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SSOAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "sso",
                                            "plural": false,
                                            "selections": [
                                                (v14 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuthenticationTargetFilter",
                                                    "kind": "LinkedField",
                                                    "name": "targetFilter",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "admin",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "kind": "LinkedField",
                            "name": "charCount",
                            "plural": false,
                            "selections": [
                                (v14 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "min",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaConfiguration",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TwitterMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "twitter",
                                    "plural": false,
                                    "selections": (v15 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "YouTubeMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "youtube",
                                    "plural": false,
                                    "selections": (v15 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GiphyMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "giphy",
                                    "plural": false,
                                    "selections": [
                                        (v14 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maxRating",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExternalMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": (v15 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "RTEConfiguration",
                            "kind": "LinkedField",
                            "name": "rte",
                            "plural": false,
                            "selections": [
                                (v14 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "strikethrough",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "spoiler",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sarcasm",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "kind": "LinkedField",
                            "name": "closeCommenting",
                            "plural": false,
                            "selections": [
                                (v57 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberBios",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StaffConfiguration",
                            "kind": "LinkedField",
                            "name": "staff",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "staffLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "adminLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderatorLabel",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "249e0a1a36e7478a38948e42ac210c1e",
            "metadata": {},
            "name": "UnansweredCommentsTabQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '2b55f5db051a4ea04c3b0ce464613d7b';
export default node;
